module.exports = __webpack_public_path__ + "img/young-f2h.97dc66da.png";